import type { FC } from 'react';

import { useParams } from '@tanstack/react-router';

import CheckboxGroupFieldWrapper from '../../../ui/forms/field_wrappers/checkbox_group/checkbox_group';

import switchStyles from '../../../components/search_facets/search_facets.module.css';
import styles from './search_in_subcollections.module.css';

type Props = {
  value: boolean;
};

const SearchInSubcollections: FC<Props> = ({ value }) => {
  const { id: collectionId } = useParams({ strict: false });

  if (!collectionId) {
    return null;
  }

  return (
    <CheckboxGroupFieldWrapper
      name="filters.ancestor_collections"
      value={value ? [collectionId] : []}
      options={[
        {
          label: 'Search in subcollections',
          value: collectionId,
        },
      ]}
      className={styles.switch_filter}
      labelClassName={switchStyles.facet_label}
      checkboxClassName={switchStyles.facet_control}
    />
  );
};

export default SearchInSubcollections;
